module.exports = __webpack_public_path__ + "static/footer-d3dab1cea97e0a125827742d3684b880.png";